module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("“Let Enkidu go ahead of you;"), _c('br'), _vm._v("for he knows the road to the Cedar Forest…”")]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_vm._v("—Tablet III"), _c('br'), _c('em', [_vm._v("The Epic of Gilgamesh")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-798228ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatterb.vue
// module id = 78
// module chunks = 0